import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgxEchartsModule } from 'ngx-echarts';
import { KeycloakInitService } from './shared/auth-services/keycloak-init.service';
import { KeycloakService } from 'keycloak-angular';
import { authHeadersInterceptor } from './interceptors/auth-headers.interceptor';
import { PlatformService } from '../../../my-shared-lib/src/lib/shared-services/platform.service.service';
import { ConfigService } from '../../../my-shared-lib/src/lib/shared-services/config.service';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      NgxEchartsModule.forRoot({ echarts: () => import('echarts') })
    ),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authHeadersInterceptor])),

    // Keycloak initializer
    {
      provide: APP_INITIALIZER,
      useFactory: (KeycloakInitService: KeycloakInitService) => () =>
        KeycloakInitService.initKeycloak(),
      multi: true,
      deps: [KeycloakInitService],
    },

    // Platform API URL initializer
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => () => {
        configService.platformApiUrl = environment.platformApiUrl;
      },
      multi: true,
      deps: [ConfigService],
    },

    // Platform API initializer
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (platformService: PlatformService) => () => platformService.getDashboardConfigFromApi('oh', 'customer-overview').toPromise(),
    //   multi: true,
    //   deps: [PlatformService],
    // },

    KeycloakService,
    // PlatformService,
  ],
};
